import { ChangeEvent, MutableRefObject, useState } from 'react';
import styled from 'styled-components';
import mapboxgl from 'mapbox-gl';
import AddressSearch from '../public-suitability-tool/components/AddressSearch';

interface LandAdvisorLocationSearchProps {
  mapRef: MutableRefObject<mapboxgl.Map | null>;
  zoom: number;
}

const StyledAddressSearch = styled(AddressSearch)`
  border-radius: 32px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  background: #fff;
  padding: 0.5rem 1rem;
  width: 100%;
  max-width: 400px;
  min-width: 0;
  box-sizing: border-box;
  overflow: hidden;
  margin-left: 0;
  margin-right: 0;
  display: block;
  font-size: 0.9rem;
`;

const LandAdvisorLocationSearch = ({
  mapRef,
  zoom,
}: LandAdvisorLocationSearchProps) => {
  const [mapAddress, setMapAddress] = useState('');
  const submit = ({
    address,
    center,
  }: {
    address: Nullable<string>;
    center: Nullable<{ lng: number; lat: number }>;
  }) => {
    if (!mapRef.current) return;

    if (center) {
      mapRef.current.flyTo({
        center: [center.lng, center.lat],
        zoom,
      });
    }

    if (address) {
      setMapAddress(address);
    }
  };

  return (
    <StyledAddressSearch
      className="flex-shrink-0"
      onChange={(e: ChangeEvent<HTMLInputElement>) =>
        setMapAddress(e.target.value)
      }
      placeholder="Search address..."
      submit={submit}
      value={mapAddress}
    />
  );
};

export default LandAdvisorLocationSearch;
